export { default } from './content-wrapper';
